import React from 'react';
import numeral from 'numeral';
import { Circle, Popup } from 'react-leaflet';

export const statOptions = {
  cases: {
    color: 'rgb(255, 0, 0)',
    rgba: 'rgba(255, 0, 0, 0.5)',
    multiplier: 700
  },
  recovered: {
    color: '#adff2f',
    rgba: 'rgba(173, 255, 47, 0.5)',
    multiplier: 750
  },
  deaths: {
    color: '#370363',
    rgba: 'rgba(55, 3, 99, 0.5)',
    multiplier: 900
  }
};

export const findCountry = (countries, selectedCountry) =>
  selectedCountry === GLOBAL_IDENTIFIER
    ? countries[countries.length - 1]
    : countries.find(({ countryInfo }) => countryInfo.iso2 === selectedCountry);

export const sortCountries = countries =>
  countries.slice(0, countries.length - 1).sort((a, b) => b.cases - a.cases);

export const buildMap = (countries, statType = 'cases') =>
  sortCountries(countries).map((country, index) => (
    <Circle
      key={`${country.countryInfo._id}-map-circle-${index}`}
      center={[country.countryInfo.lat, country.countryInfo.long]}
      fillOpacity={0.4}
      color={statOptions[statType].color}
      fillColor={statOptions[statType].color}
      radius={Math.sqrt(country[statType]) * statOptions[statType].multiplier}>
      <Popup>
        <div className="info-container">
          <div
            className="info-flag"
            style={{ backgroundImage: `url(${country.countryInfo.flag})` }}
          />
          <h2>{country.country}</h2>
          <div>Cases: {numeral(country.cases).format('0,0')}</div>
          <div>Recovered:{numeral(country.recovered).format('0,0')}</div>
          <div>Deaths: {numeral(country.deaths).format('0,0')}</div>
        </div>
      </Popup>
    </Circle>
  ));

export const buildLineGraph = (canvas, country, data, statType) => {
  const ctx = canvas.getContext('2d');
  const gradient = ctx.createLinearGradient(0, 0, 100, 0);

  const buildChartData = () => {
    const chartData = [];
    let prevDatePoint;
    for (let date in data[statType]) {
      if (prevDatePoint)
        chartData.push({ x: date, y: data[statType][date] - prevDatePoint });
      prevDatePoint = data[statType][date];
    }
    return chartData;
  };

  const chartData = buildChartData();
  return {
    backgroundColor: gradient,
    datasets: [
      {
        label: `${country.country} new ${statType}`,
        data: chartData,
        borderWidth: 1,
        fill: true,
        borderColor: statOptions[statType].color,
        backgroundColor: statOptions[statType].rgba
      }
    ]
  };
};

export const GLOBAL_IDENTIFIER = 'Global';
export const GLOBAL_COORDS = { lat: 34.80746, long: -40.4796 };
export const isGlobal = ({ country }) => country === GLOBAL_IDENTIFIER;
